
  const titles = document.querySelectorAll(".custom-animation-title");

  function revealOnScroll() {
    titles.forEach((title) => {
      const windowHeight = window.innerHeight;
      const elementTop = title.getBoundingClientRect().top;

      if (elementTop < windowHeight - 100) {
        title.classList.add("show");   // show when visible
      } else {
        title.classList.remove("show"); // hide when out of view
      }
    });
  }

  window.addEventListener("scroll", revealOnScroll);


  // Animation code
  // AOS.init({
  //   duration: 1000,
  //   once: false,   // 🔥 IMPORTANT (animate every time)
  //   mirror: true   // 🔥 animate again when scrolling up
  // });

  AOS.init({
  duration: 1000,
  once: false,   // for scroll up/down
  offset: 120,
  easing: 'ease-in-out'
});